import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import * as React from 'react';

interface RolesPopoverProps {
  roles: string[];
}

const RolesPopover: React.FC<RolesPopoverProps> = ({ roles }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'roles-popover' : undefined;

  // If no roles exist, render nothing.
  if (!roles || roles.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {/* Always display the first role */}
      <Typography variant="body2">{roles[0]}</Typography>
      {/* If more roles exist, render the More button with popover */}
      {roles.length > 1 && (
        <>
          <IconButton onClick={handleClick} size="small">
            <MoreHorizIcon />
          </IconButton>
          <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
            <Box sx={{ p: 2 }}>
              {_.map(_.slice(roles, 1), (role, index) => (
                <Typography key={index} variant="body2">
                  {role}
                </Typography>
              ))}
            </Box>
          </Popover>
        </>
      )}
    </Box>
  );
};

export default RolesPopover;
